// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
}

#search {
  width: 100%;
  height: 100% !important;
  overflow: auto !important;
}

.text {
  padding-right: 14px;
}

mat-card {
  width: 285px !important;
}

.draft-container {
  display: block !important;
  margin-top: 0 !important;
}

.owner-icon {
  width: 27px;
  height: 27px;
  background: #4A4A4A;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  vertical-align: sub;
  margin-right: 6px;
}

.template-name {
  font-size: 12px;
  font-weight: bold;
  text-decoration: underline;
}

.section-name {
  font-size: 12px;
  font-weight: bold;
  margin-top: 15px;
}

.bottom-text {
  margin-top: 3em !important;
}

.creation-date {
  font-size: 12px;
}

.section-type {
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(74, 74, 74, 0.5);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  text-align: center;
  line-height: 32px;
  font-size: 10px;
}

.research-draft-card {
  border-radius: 10px;
  width: 325px;
  display: inline-block;
  margin: 10px;
  padding: 0;
  cursor: pointer;
  vertical-align: top;
}

.file-uploader {
  position: fixed;
  bottom: 10px;
  right: 10px;
}

.action-button {
  position: absolute;
  right: -5px;
  top: 0;
}

.draft-text {
  font-size: 13px;
  border-top: 1px solid black;
  margin-top: 15px;
  padding-top: 14px;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: -15px;
}

ul {
  list-style: none;
  padding: 0px;
  margin-top: 72px;
  display: flex;
  width: 100%;
  justify-content: space-around;
}

.search-box {
  background-color: #ffffff;
  position: relative;
  border-radius: 10px;
  width: 325px;
  overflow: hidden;
}
.search-box .search-head {
  list-style: none;
  padding: 10px;
  margin: 0px;
  background-color: #f4f4f4;
  display: flex;
  justify-content: space-between;
}
.search-box .search-head .text {
  color: #4A4A4A;
  font-size: 14px;
  line-height: 26px;
}
.search-box .search-content {
  background-color: #ffffff;
  padding: 15px;
  position: relative;
}
.search-box .search-content h2.head-link {
  line-height: normal;
  font-size: 14px;
  text-decoration-line: underline;
  color: #000000;
  margin: 0;
  margin-bottom: 10px;
}
.search-box .search-content h2.head-link a {
  color: inherit;
}
.search-box .search-content .project-list {
  list-style: disc;
  padding-left: 15px;
  margin: 0px;
  line-height: normal;
  font-size: 14px;
  width: auto;
  display: block;
}
.search-box .search-content .color-btn {
  list-style: none;
  padding: 0px;
  margin: 0px;
  float: right;
  display: block;
  position: absolute;
  right: 0px;
  width: 110px;
  top: 15px;
  right: 15px;
}
.search-box .search-content .color-btn li {
  display: block;
  text-align: center;
  width: 100%;
}
.search-box .search-content .color-btn li button {
  background-color: #FFFFFF;
  border: 0.5px solid #00D3CC;
  box-sizing: border-box;
  border-radius: 14px;
  font-size: 14px;
  letter-spacing: 0.145455px;
  color: #00D3CC;
  padding: 5px;
  text-align: center;
  width: 100%;
  margin-bottom: 12px;
}
.search-box .search-content .color-btn li button img {
  margin-right: 10px;
}
.search-box .search-content .bottom-text {
  margin-top: 8em;
}
.search-box .search-content .bottom-text h2 {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
}
.search-box .search-content .bottom-text h2 img {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/ideas-wall/core/ideas-wall-item/ideas-wall-item.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAGA;EACE,WAAA;EACA,uBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,wBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,MAAA;AAAF;;AAIA;EACE,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AADF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,6BAAA;AAHF;;AAKA;EACE,yBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,YAAA;EACA,gBAAA;AAHF;AAIE;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;AAFJ;AAGI;EACE,cAAA;EAEA,eAAA;EACA,iBAAA;AAFN;AAKE;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;AAHJ;AAII;EAEE,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAHN;AAIM;EACE,cAAA;AAFR;AAMI;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EAEA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AALN;AAOI;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AALN;AAOM;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AALR;AAMQ;EACE,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AALV;AAMU;EACE,kBAAA;AAJZ;AASI;EACE,eAAA;AAPN;AAQM;EAEE,eAAA;EACA,SAAA;EACA,iBAAA;AAPR;AASQ;EACE,kBAAA;AAPV","sourcesContent":[":host {\n  display: inline-block;\n}\n\n\n#search {\n  width: 100%;\n  height: 100% !important;\n  overflow: auto !important;\n}\n\n.text {\n  padding-right: 14px;\n}\n\nmat-card {\n  width: 285px !important;\n}\n\n.draft-container {\n  display: block !important;\n  margin-top: 0 !important;\n}\n\n.owner-icon {\n  width: 27px;\n  height: 27px;\n  background: #4A4A4A;\n  border-radius: 50%;\n  color: white;\n  font-size: 18px;\n  line-height: 27px;\n  text-align: center;\n  vertical-align: sub;\n  margin-right: 6px;\n}\n\n.template-name {\n  font-size: 12px;\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.section-name {\n  font-size: 12px;\n  font-weight: bold;\n  margin-top: 15px;\n}\n\n.bottom-text {\n  margin-top: 3em !important;\n}\n\n.creation-date {\n  font-size: 12px;\n}\n\n.section-type {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 10px rgba(74, 74, 74, 0.5);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 32px;\n  font-size: 10px;\n}\n\n.research-draft-card {\n  border-radius: 10px;\n  width: 325px;\n  display: inline-block;\n  margin: 10px;\n  padding: 0;\n  cursor: pointer;\n  vertical-align: top;\n}\n\n.file-uploader {\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n}\n\n.action-button {\n  position: absolute;\n  right: -5px;\n  top: 0;\n}\n\n\n.draft-text {\n  font-size: 13px;\n  border-top: 1px solid black;\n  margin-top: 15px;\n  padding-top: 14px;\n  white-space: pre-wrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-bottom: -15px;\n}\n\n//#search{\n//width: 100%;\nul{\n  list-style:none;\n  padding:0px;\n  margin-top:72px;\n  display:flex;\n  width:100%;\n  justify-content:space-around;\n}\n.search-box{\n  background-color:#ffffff;\n  position: relative;\n  //box-shadow: 0px 2px 20px rgba(161, 161, 161, 0.07);\n  border-radius: 10px;\n  width: 325px;\n  overflow: hidden;\n  .search-head{\n    list-style:none;\n    padding:10px;\n    margin:0px;\n    background-color: #f4f4f4;\n    display:flex;\n    justify-content:space-between;\n    .text{\n      color: #4A4A4A;\n      //font-family:'nexabold';\n      font-size:14px;\n      line-height: 26px;\n    }\n  }\n  .search-content{\n    background-color:#ffffff;\n    padding:15px;\n    position: relative;\n    h2.head-link{\n      //font-family:'nexabold';\n      line-height: normal;\n      font-size: 14px;\n      text-decoration-line: underline;\n      color: #000000;\n      margin:0;\n      margin-bottom:10px;\n      a{\n        color:inherit;\n      }\n\n    }\n    .project-list{\n      list-style: disc;\n      padding-left: 15px;\n      margin:0px;\n      //font-family:'nexabold';\n      line-height: normal;\n      font-size: 14px;\n      width: auto;\n      display: block;\n    }\n    .color-btn{\n      list-style: none;\n      padding: 0px;\n      margin: 0px;\n      float: right;\n      display:block;\n      position: absolute;\n      right: 0px;\n      width: 110px;\n      top: 15px;\n      right: 15px;\n\n      li{\n        display:block;\n        text-align:center;\n        width: 100%;\n        button{\n          background-color: #FFFFFF;\n          border: 0.5px solid #00D3CC;\n          box-sizing: border-box;\n          border-radius: 14px;\n          //font-family:'nexa';\n          font-size: 14px;\n          letter-spacing: 0.145455px;\n          color: #00D3CC;\n          padding: 5px;\n          text-align: center;\n          width: 100%;\n          margin-bottom: 12px;\n          img{\n            margin-right:10px;\n          }\n        }\n      }\n    }\n    .bottom-text{\n      margin-top: 8em;\n      h2{\n        //font-family:'nexabold';\n        font-size: 14px;\n        margin:0;\n        line-height:20px;\n\n        img{\n          margin-right:10px;\n        }\n      }\n    }\n    //}\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
